import React, { Component } from "react";
import Button from "./UI/Button";
import renderActionButton from "./ActionButton";

export default class FormActions extends Component {
  render() {
    const { isLastPage, page, invalid, submitting, quit, previous, next } = this.props;
    return (
      <div className="buttons margin-top-5 form-actions">
        <div>{renderActionButton("Save & Quit", quit, "cancel")}</div>
        <div>
          {page > 0 && renderActionButton("Back", previous, "outline")}
          {!isLastPage ? (
            renderActionButton("Continue", next, "blue")
          ) : (
            <Button type="submit" coloring="green" disabled={invalid || submitting}>
              Submit
            </Button>
          )}
        </div>
      </div>
    );
  }
}
